import { Box, Grid } from '@mui/material';
import React from 'react';
import { CmpTypographyField } from '../../../component/ToolBox/ToolBox';
import moment from 'moment';
import VerifiedIcon from '@mui/icons-material/Verified';

export const VanItemCard = ({
  xTransId,
  xLoc,
  xDate,
  // xRefVocType,
  // xRefTruck,
  xlocName,
  xApBy,
  xApDt,
  xStatus,
  // xRefVocNo,
  xOnClick
}) => {
  return (
    <Box sx={{ flexGrow: 1 }} padding={'10px !important'} className="border-card-2">
      <Grid container onClick={xOnClick} spacing={0} columns={{ xs: 12, sm: 12, md: 12 }}>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Trans.Id'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={7} sm={6} md={6}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xTransId}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={1} sm={1} md={1}>
              <VerifiedIcon
                sx={{ fontSize: '20px !important', color: xStatus ? ' #0a7812' : '#e5de0f' }}
              />
            </Grid>
            <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Trans.Date'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={moment(xDate).format('DD/MM/YYYY')}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Location'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xLoc}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            {/* <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Ref.VocType'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xRefVocType}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid> */}
            {/* <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Ref.VocNo'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid> */}
            {/* <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xRefVocNo}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid> */}
            {/* <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'Ref.Truck'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid> */}
            {/* <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xRefTruck}
                sx={{ fontSize: '12px !important' }}
              /> */}
            {/* </Grid> */}

            <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'ApBy'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xApBy ?? '-'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={4} sm={5} md={5}>
              <CmpTypographyField
                xVariant="h4"
                xText={'ApDt'}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
            <Grid item xs={8} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={xApDt === null ? '-' : moment(xApDt).format('DD/MM/YYYY')}
                sx={{ fontSize: '12px !important' }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
